import React, { useMemo } from "react";
import { View, StyleSheet } from "react-native";
import NtText from "./NtText";
import { useTheme } from "../context/ThemeContext";

function NtModalError({ containerStyle, error, text }) {
  const { theme } = useTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);
  const msg = error || text;
  if (!msg) return null;
  return (
    <View style={[styles.container, containerStyle]}>
      <NtText style={styles.text}>{msg}</NtText>
    </View>
  );
}

const makeStyles = (t) =>
  StyleSheet.create({
    container: {
      marginTop: 6,
      padding: 8,
      borderRadius: t.radius,
      backgroundColor: t.red + "1A", // ~10% alpha
      borderWidth: 1,
      borderColor: t.red + "40",
    },
    text: { color: t.red, fontSize: 12, fontWeight: "500" },
  });

export default NtModalError;
